import axios from 'axios'

export const StreamAPI = {
    test1() {
        return axios({
            method: 'post',
            url: process.env.BASE_API + '/api/chat/sse/test1',
            // url: 'http://127.0.0.1:8083/api/chat/stream',
            data: { "content": this.content },
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'text/event-stream',
            },
            onDownloadProgress: (progressEvent) => {
                var response = progressEvent.event.target.responseText
                console.info(response)
                this.markdownText = response
            },
        })
    },
    async chat(data, onMessage) {
        try {
            return await axios({
                method: 'post',
                url: process.env.BASE_API + '/api/chat/stream',
                // url: 'https://api.laicj.cn/api/chat/stream',
                data: data,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'text/event-stream',
                    'Cache-Control': 'no-cache, no-store, max-age=0, must-revalidate'
                },
                responseType: 'text',
                timeout: 120000,
                onDownloadProgress: (progressEvent_1) => {
                    var response = progressEvent_1.event.target.responseText
                    onMessage(response)
                }
            })
        } catch (e) {
            console.warn(e)
        }
    }
}


// WEBPACK FOOTER //
// ./src/api/stream.js